<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
  #app {
    /*display: flex;*/
    /*flex-direction: row;*/
    /*justify-content: center;*/
    /*align-items: normal;*/
    /*position: relative;*/
    background-color: #24293c;
    /*width: 100%;*/
    /*height: 100%;*/
    /*overflow: hidden!important;*/
    /*overflow: hidden;*/
  }
</style>



// WEBPACK FOOTER //
// src/App.vue